module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_04.9d54ed8a.png";